import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE_LOCATIONS_TABLE } from '../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns } from './grid-config';
import { html, TemplateResult } from 'lit';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates } from '../utils/validators';
import { GRID_ITEM_FORM_ID } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { RelayUpdateLocationItem } from '@nirvana/shared/dtos/types/policies/common';

@customElement(WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE_LOCATIONS_TABLE)
export class GzRelayUpdateLocationsTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  RelayUpdateLocationItem,
  RelayUpdateLocationItem
> {
  // bind this for access to edited row index
  protected columns = getTableColumns();

  protected renderGridItemForm(): TemplateResult {
    return html` <gz-policy-panel-relay-update-location-item
      id="${GRID_ITEM_FORM_ID}"
    ></gz-policy-panel-relay-update-location-item>`;
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: RelayUpdateLocationItem): ValidationResult {
    // check for duplicates
    return validateDuplicates(gridItemFormValue, this.gridComponent.getFormValue());
  }

  protected validateGridItemBeforeEdit(
    oldItem: RelayUpdateLocationItem,
    newItem: RelayUpdateLocationItem
  ): ValidationResult {
    // skip if item is not changed
    if (newItem.useProxy === oldItem.useProxy && newItem.server === oldItem.server) {
      return { valid: true };
    }

    return this.validateGridItemBeforeAdd(newItem);
  }
}
